import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLocation } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles = ['admin'] }) => {
  const { currentUser } = useAuth();
  const location = useLocation();

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Treat 'user' role as equivalent to 'employee' role
  // Also allow supervisor role to access employee routes
  const effectiveRole = currentUser.role === 'user' ? 'employee' : currentUser.role;
  
  // If the route allows 'employee' access, also allow 'supervisor' access
  const effectiveAllowedRoles = allowedRoles.includes('employee') ? 
    [...allowedRoles, 'supervisor'] : allowedRoles;
  
  if (!effectiveAllowedRoles.includes(effectiveRole)) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
